import { useState } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';

const DEFAULT_DELAY = 1000;

export const useNavigateWithDelay = (delay = DEFAULT_DELAY) => {
  const [isNavigating, setNavigating] = useState(false);
  const navigate = useNavigate();

  const delayedNavigate = (
    path: string,
    options?: NavigateOptions,
    onNavigate?: () => void,
  ) => {
    setNavigating(true);

    setTimeout(() => {
      onNavigate && onNavigate();
      navigate(path, options);
    }, delay);
  };

  return { navigate: delayedNavigate, isNavigating };
};
